import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
// 原始的公用请求头配置
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 埋点上报
export const trackingPoint = (data: any) =>
  request.post('/datacenter/user/burial/report', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
